const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const isMobile = Odigeo.SessionScope.flow === 'mobile';

module.exports = createWidgetFactory({
    name: 'seats_wrapper_postbooking',
    viewClass: isMobile ? require('./view.mobile') : require('./view.desktop'),
});
